import React, { useState } from 'react'
import get from 'lodash/get'
import { Link } from 'react-router-dom'

import searches from '../../../../../utils/routing/searches'
import ReactPlayer from 'react-player'

export default function TopJobs(props) {
  const topJobs = get(props, 'topJobs')
  const [playingVideoUrl, setPlayingVideoUrl] = useState(null)
  const playVideo = playingVideoId => setPlayingVideoUrl(playingVideoId)

  return topJobs.slice(0, 3).map(job => {
    const { videoUrl } = job

    return (
      <div key={job.title} className="row" style={{ marginBottom: 40, padding: '0 20px' }}>
        <div className="col-8">
          <Link
            to={searches.buildUrlForSavedResumeSearch({
              searchParams: {
                searchType: 'career',
                search_query: job.title,
              },
            })}
          >
            <div className="d-flex">
              <i className="fal fa-search p-1" />
              <h4 className="btn-link">{job.title}</h4>
            </div>
          </Link>
          <p>{job.description}</p>
        </div>

        <div className="col-4">
          <div className="embed-responsive embed-responsive-16by9">
            <ReactPlayer
              controls
              width="100%"
              height="100%"
              playing={videoUrl === playingVideoUrl}
              url={videoUrl}
              onPlay={() => playVideo(videoUrl)}
              onEnded={() => playVideo(null)}
            />
          </div>
        </div>
      </div>
    )
  })
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/PersonalityAssessment/components/components/TopJobs.js